/* eslint-disable react/prop-types */
import {TextField, Select, MenuItem, RadioGroup, FormControlLabel, Radio, Grid} from '@mui/material';

export const fieldRenderers = {
  Text: ({field, sx}) => <TextField {...field} size="small" sx={sx} />,

  Any: ({field, sx}) => <TextField {...field} size="small" sx={sx} />,

  Number: ({field, sx}) => <TextField {...field} type="number" inputProps={{step: 'any'}} size="small" sx={sx} />,

  Date: ({field, sx}) => <TextField {...field} type="date" size="small" InputLabelProps={{shrink: true}} sx={sx} />,

  DateTime: ({field, sx}) => <TextField {...field} type="datetime-local" size="small" sx={sx} />,

  Logical: ({field}) => (
    <RadioGroup row {...field}>
      <FormControlLabel value="True" control={<Radio size="small" />} label="True" />
      <FormControlLabel value="False" control={<Radio size="small" />} label="False" />
    </RadioGroup>
  ),

  // Business need, for now this field type is always disabled
  Binary: ({field}) => (
    <Select disabled {...field} size="small">
      <MenuItem value="0">0</MenuItem>
      <MenuItem value="1">1</MenuItem>
    </Select>
  )
};
